import React from 'react';
import { ActionButton } from '../../components/ui/ActionButton';
import { useAnnualPlanTranslation } from '../../hooks/useAnnualPlanTranslation';
import { STRENGTH_OBJECTIVE_TEMPLATES, type StrengthObjectiveTemplate } from './strengthObjectives';

export function StrengthObjectiveTemplates({ scope, disabled, onSelect, onBuild }: {
  scope: 'week' | 'phase';
  disabled?: boolean;
  onBuild?: () => void;
  onSelect: (template: StrengthObjectiveTemplate) => void;
}) {
  const { t } = useAnnualPlanTranslation();
  return <div className="atp-strength-templates">
    <h4>{t('annualPlan.strengthGoals.title')}</h4>
    <div className="atp-strength-options" role="group" aria-label={t(`annualPlan.strengthGoals.${scope}Templates`)}>
      {STRENGTH_OBJECTIVE_TEMPLATES.map(template => <ActionButton key={template} disabled={disabled} wrap
        onClick={() => onSelect(template)}>{t(`annualPlan.strengthGoals.templates.${template}.title`)}</ActionButton>)}
    </div>
    {onBuild&&<ActionButton className="atp-strength-build" disabled={disabled} onClick={onBuild}>{t('annualPlan.strengthPlan.title')}</ActionButton>}
    <details className="atp-strength-guide">
      <summary>{t('annualPlan.strengthGoals.guideTitle')}</summary>
      <p>{t('annualPlan.strengthGoals.hint')}</p>
      <ul>{STRENGTH_OBJECTIVE_TEMPLATES.map(template => <li key={template}>
        <strong>{t(`annualPlan.strengthGoals.templates.${template}.title`)}</strong>
        <p>{t(`annualPlan.strengthGoals.templates.${template}.guide`)}</p>
      </li>)}</ul>
      <p>{t('annualPlan.strengthGoals.measurement')}</p>
      <ul>
        <li><a href="https://pubmed.ncbi.nlm.nih.gov/41843416/" target="_blank" rel="noopener noreferrer">{t('annualPlan.strengthGoals.acsmSource')}</a></li>
        <li><a href="https://pubmed.ncbi.nlm.nih.gov/26641569/" target="_blank" rel="noopener noreferrer">{t('annualPlan.strengthGoals.cyclingSource')}</a></li>
      </ul>
    </details>
  </div>;
}
